import { Component,Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { InviteEarnService } from '@app-services/invite-earn/invite-earn.service';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-share-dialog-referral',
  templateUrl: './share-dialog-referral.component.html',
  styleUrls: ['./share-dialog-referral.component.css']
})
export class ShareDialogReferralComponent implements OnInit {
  public rootUrl:any;
  public userId:any;
  textAreaLink:any;
  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
  private dialogRef: MatDialogRef<ShareDialogReferralComponent>, 
  private _inviteNdEarn:InviteEarnService,
  private _toastr:ToastrService,
  private _router:Router
  ) { }

  ngOnInit(): void {
    this.rootUrl=this.data?.shareUrl;
    this.textAreaLink= this.data?.textUrl;
  }
  
  close() {
    this.dialogRef?.close();
  }
  copyRefCode(){
    this._toastr?.success("Text Copied!")
    navigator?.clipboard?.writeText(this.rootUrl);
  }

  sendModeOfShare(modeOfShare:any){
    let currentWindow=localStorage?.getItem('currentPage');
    let refURL="referral"
    this._inviteNdEarn?.sendModeOfShareDetails(modeOfShare,this.data?.userRferralId).subscribe((res)=>{
    })
    if(currentWindow!=refURL){
      this.navigateMyReferralDashboard();
    }else{
    }
  }
    navigateMyReferralDashboard(){
    this._router?.navigateByUrl('/dashboard/referral');
  }
}